import { RootState } from 'handlers';

export const getMethodAuthData = ({ methodAuth }: RootState) => methodAuth;
